import { render, staticRenderFns } from "./MisFormulasPage.vue?vue&type=template&id=7b12643e&scoped=true"
import script from "./MisFormulasPage.js?vue&type=script&lang=js&external"
export * from "./MisFormulasPage.js?vue&type=script&lang=js&external"
import style0 from "./MisFormulasPage.vue?vue&type=style&index=0&id=7b12643e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b12643e",
  null
  
)

export default component.exports